<template>

<pageHead></pageHead>
<router-view></router-view>
<VideoPlayer v-if="false"></VideoPlayer>
</template>

<script>
import pageHead from './components/pageHead.vue'
import VideoPlayer from '@/components/VideoPlayer.vue';
export default {
  name: 'App',
  components: {
    pageHead,
    VideoPlayer,
  },


    
  
}

</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
</style>
